// extracted by mini-css-extract-plugin
export var header = "_x6-1";
export var maskBottom = "_x6-6";
export var maskMiddle = "_x6-7";
export var maskTop = "_x6-5";
export var root = "_x6-0";
export var scrollDownButton = "_x6-3";
export var scrollDownButtonHidden = "_x6-4";
export var viewport = "_x6-2";